module.exports = __webpack_public_path__ + "static/media/driver_license.7b0016af.png";